module.exports = __webpack_public_path__ + "img/16581288_S.c015c435.png";